<template>
  <div class="shipping-page">

    <!-- Hero Section -->
    <section class="page-hero">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content" data-aos="fade-up">
          <h1 class="page-title">{{ hero.title }}</h1>
          <p class="page-subtitle">{{ hero.subtitle }}</p>
        </div>
      </div>
    </section>

    <!-- Shipping Information -->
    <section class="shipping-info text-start" v-if="shippingPolicies.length">
      <div class="container">
        <div class="section-header text-start">
          <span class="section-subtitle">Delivery Information</span>
          <h2 class="section-title-modern">Shipping Policy</h2>
          <div class="title-underline ms-0"></div>
        </div>

        <div class="policy-content">
          <div
            class="policy-item"
            v-for="(item, i) in shippingPolicies"
            :key="'shipping-' + i"
            data-aos="fade-up"
            :data-aos-delay="i * 60"
          >
            <div class="policy-icon">
              <i :class="item.icon"></i>
            </div>
            <div class="policy-text">
              <h4>{{ item.title }}</h4>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Return Policy -->
    <section class="returns-info text-start" v-if="returnPolicies.length">
      <div class="container">
        <div class="section-header text-start">
          <span class="section-subtitle">Returns & Exchanges</span>
          <h2 class="section-title-modern">Return & Exchange Policy</h2>
          <div class="title-underline ms-0"></div>
        </div>

        <div class="policy-content">
          <div
            class="policy-item"
            v-for="(item, i) in returnPolicies"
            :key="'return-' + i"
            data-aos="fade-up"
            :data-aos-delay="i * 60"
          >
            <div class="policy-icon">
              <i :class="item.icon"></i>
            </div>
            <div class="policy-text">
              <h4>{{ item.title }}</h4>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import CmsService from "../services/CmsService";
export default {
  name: 'ShippingPolicyPage',
  data() { return { page: null }; },
  computed: {
    hero()             { return this.page?.sections?.hero             || {}; },
    shippingPolicies() { return this.page?.sections?.shippingPolicies || []; },
    returnPolicies()   { return this.page?.sections?.returnPolicies   || []; },
  },
  methods: {
    load() { CmsService.getPage('shipping').then(r => { this.page = r.data.data; }).catch(() => {}); }
  },
  mounted() {
    this.load();
    if (typeof AOS !== 'undefined') AOS.init({ duration: 800, once: true, offset: 100 });
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700&display=swap');

.shipping-page {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* HERO SECTION */
.page-hero {
  height: 350px;
  background: linear-gradient(
    135deg,
    rgba(118, 172, 175, 0.95),
    rgba(98, 152, 155, 0.95)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 80px;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.hero-content {
  text-align: center;
  color: white;
  position: relative;
  z-index: 2;
}

.page-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  margin-bottom: 20px;
}

.page-subtitle {
  font-size: 1.1rem;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.7;
}

/* SECTIONS */
.shipping-info,
.returns-info {
  padding: 90px 0;
  background: #f8fafb;
}

.returns-info {
  background: white;
}

.section-header {
  margin-bottom: 50px;
}

.section-subtitle {
  color: rgb(118, 172, 175);
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  display: block;
  margin-bottom: 10px;
}

.section-title-modern {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
}

.title-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(
    90deg,
    rgb(118, 172, 175),
    rgb(98, 152, 155)
  );
  border-radius: 2px;
}

.policy-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.policy-item {
  display: flex;
  gap: 20px;
  background: white;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.returns-info .policy-item {
  background: #f8fafb;
}

.policy-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
}

.policy-icon {
  width: 55px;
  height: 55px;
  background: rgba(118, 172, 175, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.policy-icon i {
  color: rgb(118, 172, 175);
  font-size: 1.3rem;
}

.policy-text h4 {
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 10px;
}

.policy-text p,
.policy-text li {
  color: #718096;
  line-height: 1.8;
}

.policy-text ul {
  margin: 0;
  padding-left: 20px;
}

/* MOBILE */
@media (max-width: 768px) {
  .page-hero {
    height: 280px;
    margin-top: 70px;
  }

  .shipping-info,
  .returns-info {
    padding: 60px 0;
  }

  .policy-item {
    flex-direction: column;
  }
}
</style>